import { RemoveGiftCardFromCartResult } from '../../../graphql/cart/removeGiftCardFromCart';
import { createAction } from '@reduxjs/toolkit';

export interface ApiRemoveGiftCardFromCartRequestedPayload {
  readonly actionId: number;
  readonly cartId: string;
  readonly parentActionId: number;
}

export const apiRemoveGiftCardFromCartRequestedType = 'api/cart/removeGiftCardFromCart--requested';
export const apiRemoveGiftCardFromCartRequested =
  createAction<ApiRemoveGiftCardFromCartRequestedPayload>(apiRemoveGiftCardFromCartRequestedType);

export type ApiRemoveGiftCardFromCartRequestedAction = ReturnType<
  typeof apiRemoveGiftCardFromCartRequested
>;

export interface ApiRemoveGiftCardFromCartSucceededPayload {
  readonly cartId: string | null;
  readonly result: RemoveGiftCardFromCartResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiRemoveGiftCardFromCartSucceededType = 'api/cart/removeGiftCardFromCart--succeeded';
export const apiRemoveGiftCardFromCartSucceeded =
  createAction<ApiRemoveGiftCardFromCartSucceededPayload>(apiRemoveGiftCardFromCartSucceededType);

export type ApiRemoveGiftCardFromCartSucceededAction = ReturnType<
  typeof apiRemoveGiftCardFromCartSucceeded
>;

export interface ApiRemoveGiftCardFromCartFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiRemoveGiftCardFromCartFailedType = 'api/cart/removeGiftCardFromCart--failed';
export const apiRemoveGiftCardFromCartFailed = createAction<ApiRemoveGiftCardFromCartFailedPayload>(
  apiRemoveGiftCardFromCartFailedType
);
export type ApiRemoveGiftCardFromCartFailedAction = ReturnType<
  typeof apiRemoveGiftCardFromCartFailed
>;
